export type ResourceType =
  | "group"
  | "dashboard"
  | "device"
  | "user"
  | "subscription"
  | "notification";

export type ActionType =
  | "update"
  | "create"
  | "delete"
  | "login"
  | "logout"
  | "invite"
  | "remove"
  | "transfer";

export interface AuditLog {
  id: string;
  group_id: string;
  user_id: string;
  action: ActionType;
  resource_type: ResourceType;
  resource_id: string;
  timestamp: string;
  details?: string;
  ip_address?: string;
}
export interface AuditLogs {
  logs: AuditLog[];
}
export interface FilterState {
  user: string;
  resourceType: ResourceType | "";
  action: ActionType | "";
  dateRange: {
    start: Date | null;
    end: Date | null;
    preset: DatePreset | "";
  };
}

export const FilterKeys = {
  User: "user",
  ResourceType: "resourceType",
  Action: "action",
  DateRange: "dateRange",
} as const;

export type FilterKey = (typeof FilterKeys)[keyof typeof FilterKeys];

export type DatePreset =
  | "today"
  | "thisWeek"
  | "thisMonth"
  | "lastMonth"
  | "lastYear"
  | "custom";

export interface PaginationState {
  currentPage: number;
  itemsPerPage: number;
  totalItems: number;
}
